import Page from "@/components/pages/inventory/sales-order/payment/page";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import z from "zod";

const searchSchema = z.object({
  salesOrderId: z.string().optional(),
  type: z.enum(["edit", "view", "add"]).optional(),
  status: z
    .enum([
      "ALL",
      "UNPAID",
      "PARTIALLY_PAID",
      "PAID",
      "REFUND_REQUESTED",
      "REFUNDED",
      "PARTIALLY_REFUNDED"
    ])
    .catch("ALL")
    .default("ALL").optional(),
  needRefresh: z.boolean().optional(),
  // Date filtering parameters
  dateRangeStart: z.string().optional(),
  dateRangeEnd: z.string().optional(),
  dateFilter: z.enum(["today", "week", "month", "custom"]).optional(),
  // Pagination parameters
  page: z.number().min(1).optional().default(1),
  limit: z.number().min(10).max(100).optional().default(20),
  // Sorting parameters
  sortBy: z.string().optional(),
  sortOrder: z.enum(["asc", "desc"]).optional().default("desc"),
  // Filter parameters
  customerId: z.string().optional(),
  paymentMethod: z.string().optional(),
  transactionId: z.string().optional(),
  // Bulk operation parameters
  selectedOrders: z.array(z.string()).optional(),
  bulkAction: z.enum(["status_update", "export", "add_payment"]).optional(),
});

export const Route = createFileRoute("/_app/inventory/sales-order/_modal/payments")({
  component: Page,
  validateSearch: zodValidator(searchSchema),
});
